import { createWebHistory, createRouter } from "vue-router";
import routes from "@/routes/storefrontRoutes";

// Router for the public storefront app. No auth guards — every route here is public — and no
// Sentry integration, since this entry does not initialise Sentry.
const router = createRouter({
  history: createWebHistory(),
  routes,
  // Restore the previous position when coming back from a product page, so returning to a
  // filtered menu lands where the shopper left it.
  scrollBehavior: (to, from, savedPosition) => savedPosition || { top: 0 },
});

export default router;
